export { FullLogoIcon } from './FullLogoIcon';
